import React from "react";
import styles from "./styles.module.scss";
import Checkmark from "app/images/green-checkmark.svg";
import ModalLayout from "app/components/Layouts/ModalLayout/ModalLayout";
import { GroupPermissions } from "app/models/GroupsModel";
import { useTranslation } from "react-i18next";
import ButtonVariant from "app/components/Button/ButtonVariant";

interface ISuccessModal {
  data: GroupPermissions;
  isOpen: boolean;
  onClose: () => void;
}

const SuccessModal = ({ data, isOpen, onClose }: ISuccessModal) => {
  const { t } = useTranslation();

  return (
    <ModalLayout
      classNames={styles.modal_container}
      isOpen={isOpen}
      onClose={onClose}
    >
      <div className={styles.container}>
        <img src={Checkmark} alt="success" />
        <h3 className={styles.success_info}>
          {t(`Permissions for {{teamGroupName}} channel successfully added!`, {
            teamGroupName: data?.teamGroupName,
          })}
        </h3>
        <p className={styles.success_description}>
          {t("Permissions take effect only for this specific channel.")}
        </p>

        <ButtonVariant
          title={t("Ok")}
          onClickFunc={onClose}
          buttonStyles={styles.button}
          buttonType="primary"
        />
      </div>
    </ModalLayout>
  );
};

export default SuccessModal;
